import * as angular from "angular";
import {IPromise, IQService} from "angular";
import {ServicePointsAlerts} from "./service-points-alerts.service";
import {ServicePointsRequests} from "./service-points-requests.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";

export class ServicePointsService {

  /* @ngInject */
  constructor(private $q: IQService, private servicePointsRequests: ServicePointsRequests, private servicePointsAlerts: ServicePointsAlerts, private bringozLoaderService: BringozLoaderService, private $log) {
  }

  createServicePoint(servicePoint): IPromise<any> {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.servicePointsRequests.createServicePoint(servicePoint)
        .then((createdServicePoint) => {
          this.servicePointsAlerts.createSuccess();
          resolve(createdServicePoint);
        })
        .catch((error) => {
          this.$log.error(error);
          this.servicePointsAlerts.createError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  updateServicePoint(servicePoint) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.servicePointsRequests.updateServicePoint(servicePoint.id, servicePoint)
      .then((updatedServicePoint) => {
        deferred.resolve(updatedServicePoint)
        this.servicePointsAlerts.updateSuccess();
      })
      .catch((error) => {
        deferred.reject(error)
        this.servicePointsAlerts.updateError();
        this.$log.info('Failed to update service point', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }
}

angular
  .module('bringoz.admin.service-points')
  .service('servicePointsService', ServicePointsService);
